import { MouseEventHandler } from 'react';
import PlaceHolderImage from '../../assets/Placeholder.svg';
import { Box } from '@material-ui/core';

interface PhotoCoverProps {
  url: any;
  alt?: string;
  rotationDegrees: number;
  width: string;
  height: string;
  borderRadius?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  caption?: string;
}

export const PhotoCover = ({
  url,
  alt,
  rotationDegrees,
  width,
  height,
  borderRadius = '0',
  onClick,
  caption,
}: PhotoCoverProps) => {
  const safeRotation = rotationDegrees ?? 0;

  const onError = event => {
    if (event.target.src !== PlaceHolderImage) {
      event.target.src = PlaceHolderImage;
    }
  };

  return (
    <div
      style={{
        position: 'relative',
        width,
        height,
        overflow: 'hidden',
        borderRadius,
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      <img
        src={url}
        alt={alt}
        onError={onError}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          objectFit: 'cover',
          width: '100%',
          transform: `translate(-50%, -50%) rotate(${safeRotation}deg)`,
        }}
      />
      {caption && (
        <Box
          borderRadius={'16px'}
          m={0.5}
          py={0.5}
          px={1.5}
          position={'absolute'}
          left={0}
          bottom={0}
          width={'calc(100% - 8px)'}
          bgcolor={'rgba(0,0,0, 0.5)'}
          color={'white'}
        >
          {caption}
        </Box>
      )}
    </div>
  );
};
